<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <header class="mt-8 mb-24">
        <div class="d-flex justify-content-between align-items-center">
          <div *ngIf="sigla == 'CAIXA'">
            <img src="/assets/cef/logo-header.svg" />
          </div>
          <div *ngIf="sigla != 'CAIXA'">
            <img src="/assets/img/logo-header.svg" />
          </div>
          <div class="mb-1"><b>Resumo de Itens Importados</b></div>
        </div>
      </header>

      <div class="background p-3 mb-3 border">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <div class="mb-1">{{ date }}</div>
            <div>{{ companyName }} - {{ companyCNPJ }}</div>
          </div>
          <div class="d-flex gap-2 align-items-center">
            <button
              class="color-brand-principal d-print-none"
              mat-icon-button
              (click)="downloadExcel()"
              matTooltip="Baixar Excel"
              matTooltipPosition="above"
            >
              <mat-icon svgIcon="download-current"></mat-icon>
            </button>
            <button
              class="color-brand-principal d-print-none"
              mat-icon-button
              onclick="window.print()"
              matTooltip="Imprimir"
              matTooltipPosition="above"
            >
              <mat-icon svgIcon="impressora-current"></mat-icon>
            </button>
          </div>
        </div>
      </div>

      <table class="table font-size-14 table-bordered">
        <thead>
          <tr>
            <th width="14%" rowspan="2" class="background">Região</th>
            <!-- TODO -->
            <th width="10%" rowspan="2" class="background">Produto</th>
            <th colspan="2" class="background">Cód. do Benefício</th>
            <th width="24%" rowspan="2" class="background">Descrição do Benefício</th>
            <th width="8%" rowspan="2" class="background">Qtde.<br />Benefícios</th>
            <th colspan="2" class="background">Valor Unitário R$</th>
            <th colspan="2" class="background">Valor Total R$</th>
          </tr>
          <tr>
            <th width="6%" class="background">Cliente</th>
            <th width="6%" class="background">{{ sigla }}</th>
            <th width="8%" class="background">Cliente</th>
            <th width="8%" class="background">{{ sigla }}</th>
            <th width="9%" class="background">Cliente</th>
            <th width="9%" class="background">{{ sigla }}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of dataSource">
            <td [class.color-error]="hasDiferencaTarifa(item.flagDiferencaTarifa)">{{ item.distribuidor }}</td>
            <td [class.color-error]="hasDiferencaTarifa(item.flagDiferencaTarifa)">{{ item.nmProcliPro }}</td>
            <td [class.color-error]="hasDiferencaTarifa(item.flagDiferencaTarifa)">{{ item.codigoInscli }}</td>
            <td [class.color-error]="hasDiferencaTarifa(item.flagDiferencaTarifa)">{{ item.codigoInsumo }}</td>
            <td [class.color-error]="hasDiferencaTarifa(item.flagDiferencaTarifa)">{{ item.nomeInsumo }}</td>
            <td [class.color-error]="hasDiferencaTarifa(item.flagDiferencaTarifa)">{{ item.quantidadeInsumo }}</td>
            <td [class.color-error]="hasDiferencaTarifa(item.flagDiferencaTarifa)">
              {{ showValue(item.valorInsumo) }}
            </td>
            <td [class.color-error]="hasDiferencaTarifa(item.flagDiferencaTarifa)">
              {{ showValue(item.valorUnitario) }}
            </td>
            <td [class.color-error]="hasDiferencaTarifa(item.flagDiferencaTarifa)">
              {{ showValue(item.valorTotalItemIPB) }}
            </td>
            <td [class.color-error]="hasDiferencaTarifa(item.flagDiferencaTarifa)">
              {{ showValue(item.valorTotalItemVTO) }}
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td colspan="6" class="text-end background"><b>Total:</b></td>
            <td colspan="2" class="text-center background">
              <b>{{ showValue(total) }}</b>
            </td>
            <td colspan="2" class="text-center background">
              <b>{{ showValue(totalDiff) }}</b>
            </td>
          </tr>
          <tr>
            <td colspan="6" class="text-end background"><b class="color-brand-principal">Diferença:</b></td>
            <td colspan="4" class="text-center background">
              <b class="color-brand-principal">{{ showValue(diff, true) }}</b>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
